import mutations from './userManagement/mutations'
import getters from './userManagement/getters'
import actions from './userManagement/actions'

const state = {
  recentlyAddedUsersLoading: true,
  recentlyAddedUsers: [],
  recentlyAddedUsersMessage: '',

  recentlyUpdatedUsersLoading: true,
  recentlyUpdatedUsers: [],
  recentlyUpdatedUsersMessage: '',

  pendingUsersLoading: true,
  pendingUsers: [],
  pendingUsersMessage: ''
}

export const userManagement = { namespaced: false, state, getters, mutations, actions }
